import { Link } from 'react-router-dom';
import { comics } from '@/mocks/manga';
import { popularRanking } from '@/mocks/featured';

export default function RankingSection() {
  const ranking = popularRanking.map(id => comics.find(c => c.id === id)).filter(Boolean) as typeof comics;

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">人气排行</h2>
            <p className="text-sm text-foreground-500 mt-1">站内最受欢迎的热门漫画</p>
          </div>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {ranking.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${
                index < ranking.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                index === 0 ? 'bg-primary-500 text-background-50' :
                index === 1 ? 'bg-primary-400 text-background-50' :
                index === 2 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 古古漫画网`}
                  title={`${comic.title} - 人气排行第${index + 1}名`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">{comic.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <div className="flex flex-wrap items-center gap-1.5 mt-1">
                  {comic.tags.slice(0, 3).map(tag => (
                    <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-600">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-xs text-foreground-400 flex-shrink-0">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-amber-400 text-sm"></i>
                  {comic.rating}
                </span>
                <span>{comic.status}</span>
                <span>{(comic.views / 10000).toFixed(0)}万阅读</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}